import { baseDefaultContextProps } from '../../constants/props';
import { unauthorizedRoutesParam } from '../../constants/routes';
export const defaultPageLayoutProps = Object.assign({}, baseDefaultContextProps, {
  recurringMeetings: [],
  routes: {
    comments: '/comments',
    outsideMeeting: '/outside-active-meeting',
    draft: '/draft',
    contacts: '/contacts',
    associations: '/associations',
    base: '/in-meeting-experience-ui-components-kitchen-sink',
    accounts: '/accounts'
  },
  resetStateBetweenCallObjects: () => undefined,
  meetingTopic: 'Meeting',
  currentAccount: {},
  firstName: 'Brian',
  lastName: 'Halligan (Sample)',
  tabsConfig: [],
  unauthorizedRoutesParam,
  initMethod: () => undefined,
  isPreviousMeetingsMenuOpen: false,
  togglePreviousMeetingsMenuOpen: () => undefined,
  setMeetingContext: () => undefined,
  canViewParticipants: true,
  showHeader: true,
  showInCallTitle: true,
  useTheme: 'default',
  tabContainerHeight: '100%',
  showPlannerBackButton: false,
  participants: [],
  notifications: [],
  myParticipantRole: undefined,
  meetingID: '',
  isDemoApp: false
});